import {getHistory, getPoslogByTransactionId, getXML} from "../../../requesters/apiV3Requesters";
import vkbeautify from 'vkbeautify';
import {parameters} from "@/parameters";
import {NOTIFICATION_NS} from "@/store/modules/notification/constants";

const actions = {
    refreshPoslogData({commit, dispatch}, {transactionId, messageDateTime, version, anonymized}) {
        // Maj current state
        commit('updateTransactionId', transactionId);
        commit('updateAnonymized', anonymized);
        dispatch('cleanPoslogData');

        // Fetch correct data from main API
        getPoslogByTransactionId(transactionId, !anonymized)
            .then(poslog => commit('updatePoslogApi', poslog))
            // eslint-disable-next-line no-console
            .catch(error => console.log(error));

        // Need to fetch XML separably
        dispatch('fetchXML', {messageDateTime, version});
    },
    fetchXML({getters, commit}, {messageDateTime, version}) {
        commit('updateMessageDateTime', messageDateTime);
        commit('updateVersion', version);

        getXML(getters.transactionId, messageDateTime, version, !getters.anonymized)
            .then(poslogXML => {
                commit(
                    'updateXml',
                    vkbeautify.xml(poslogXML)
                );
            })
            .catch(error => {
                commit('updateXml', error);
            });
    },
    fetchHistory({getters, commit}) {
        getHistory(getters.transactionId)
            .then((response) => {
                commit('updateHistory', response);
            });
    },
    switchTo({dispatch}, view) {
        switch (view) {
            case 'json': dispatch('switchToJson'); break;
            case 'receipt': dispatch('switchToReceipt'); break;
            case 'history': dispatch('switchToHistory'); break;
            default: dispatch('switchToXml');
        }
    },
    switchToXml({commit}) {
        commit('updateDownloadMeta', {ext: 'xml', contentType: 'application/xml'});
        commit('updateLang', 'xml');
        commit('updateCurrentView', 'xml');
    },
    switchToJson({commit}) {
        commit('updateDownloadMeta', {ext: 'json', contentType: 'application/json'});
        commit('updateLang', 'json');
        commit('updateCurrentView', 'json');
    },
    switchToReceipt({commit}) {
        commit('updateDownloadMeta', {ext: 'txt', contentType: 'text/plain'});
        commit('updateLang', 'plaintext');
        commit('updateCurrentView', 'receipt');
    },
    switchToHistory({commit}) {
        commit('updateCurrentView', 'history');
    },
    cleanPoslogData({commit}) {
        commit('updatePoslogApi', null);
        // Need to separatly clean XML as is doesn't comes from the same API
        commit('updateXml', null);
    },
    sendToPoslogValidation({dispatch}, xml) {
        navigator.clipboard.writeText(xml)
            .then(() => {
                dispatch(
                    `${NOTIFICATION_NS}/addNotification`,
                    {
                        message: 'XMl copied to clipboard! You will be sent to PoslogValidation'
                    },
                    {root: true}
                );

                setTimeout(() => {
                    window.open(parameters.poslogValidationUrl, '_blank');
                }, 1500);
            });
    }
};

export default actions;
